/**
 * Google Analytics 4 wrapper — only activates when REACT_APP_GA_ID is set.
 * To enable, add to /app/frontend/.env:
 *   REACT_APP_GA_ID=G-XXXXXXXXXX
 * Then `sudo supervisorctl restart frontend`.
 */
const GA_ID = process.env.REACT_APP_GA_ID;

let initialized = false;

export function initAnalytics() {
    if (initialized || !GA_ID || typeof window === "undefined") return;
    initialized = true;

    // gtag.js loader
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
    document.head.appendChild(s);

    window.dataLayer = window.dataLayer || [];
    function gtag(...args) { window.dataLayer.push(args); }
    window.gtag = gtag;
    gtag("js", new Date());
    gtag("config", GA_ID, { send_page_view: true });
}

export function trackEvent(name, params = {}) {
    if (!GA_ID || typeof window === "undefined" || !window.gtag) return;
    window.gtag("event", name, params);
}

export function trackPageView(path) {
    if (!GA_ID || typeof window === "undefined" || !window.gtag) return;
    window.gtag("event", "page_view", { page_path: path });
}

export const isAnalyticsEnabled = () => Boolean(GA_ID);
